<template>
    <div>
        <h1 class="text-xl mb-6">Payment</h1>

        <form class="relative"
              @submit.prevent="proceedToPayment"
        >
            <payment-options v-model="form.payment_method"></payment-options>

            <h2>Vouchers</h2>
            <p>
                If you have a voucher code, please enter it below to apply it to your booking.
            </p>

            <form-voucher @voucher-applied="updateBasket"></form-voucher>

            <h2 class="mt-10">Contact Preferences & Terms</h2>

            <div class="font-semibold text-gray-600 mt-4">
                <div class="flex items-center">
                    <form-toggle v-model="form.marketing"></form-toggle>
                    <div class="ml-2">
                        Contact me with latest news and offers
                    </div>
                </div>

                <template v-if="basketHasEvents">
                    <div class="flex items-center mt-2"
                    >
                        <form-toggle v-model="form.adult"></form-toggle>
                        <div class="ml-2">
                            I confirm that I am at least 18 years of age
                        </div>
                    </div>

                    <div class="ml-12 mt-1 text-xs text-red-600" v-if="hasError('adult')">
                        {{ getErrorFor('adult') }}
                    </div>
                </template>

                <div class="flex items-center mt-2">
                    <form-toggle v-model="form.terms"></form-toggle>
                    <div class="ml-2">
                        I have read and agree to the <a href="/terms-and-conditions" target="_blank" class="text-primary-600 hover:underline">terms and conditions</a>
                    </div>
                </div>

                <div class="ml-12 mt-1 text-xs text-red-600" v-if="hasError('terms')">
                    {{ getErrorFor('terms') }}
                </div>

                <template v-if="basketHasEvents">
                    <div class="flex items-center mt-2">
                        <form-toggle v-model="form.weather"></form-toggle>
                        <div class="ml-2">
                            I have read and agree to the <a href="#" class="text-primary-600 hover:underline" @click.prevent="modal = 'weather'">bad weather policy</a>
                        </div>
                    </div>

                    <div class="ml-12 mt-1 text-xs text-red-600" v-if="hasError('weather')">
                        {{ getErrorFor('weather') }}
                    </div>

                    <div class="flex items-center mt-2">
                        <form-toggle v-model="form.group"></form-toggle>
                        <div class="ml-2">
                            I have read and agree to the <a href="#" class="text-primary-600 hover:underline" @click.prevent="modal = 'group'">group booking guest details policy</a>
                        </div>
                    </div>

                    <div class="ml-12 mt-1 text-xs text-red-600" v-if="hasError('group')">
                        {{ getErrorFor('group') }}
                    </div>
                </template>
            </div>

            <div class="flex justify-end mt-8">
                <form-button type="submit">
                    Continue
                </form-button>
            </div>

            <div class="absolute z-10 inset-0 bg-translucent-white-75 flex items-center justify-center"
                 v-show="loading"
            >
                <preloader></preloader>
            </div>
        </form>
        <portal to="modal">
            <modal v-if="modal"
                   @hide="modal = false;"
            >
                <template v-slot:default="props">
                    <div>
                        <h2 class="mb-2">{{ modalText['heading'] }}</h2>

                        <div class="space-y-6"
                             v-html="modalText['body']"
                        ></div>
                    </div>

                    <div class="flex justify-end mt-6">
                        <form-button colour="gray"
                                     @click.native="props.hide"
                        >
                            Close
                        </form-button>
                    </div>
                </template>
            </modal>
        </portal>
    </div>
</template>

<script>
    import PaymentOptions from "../../components/PaymentOptions";
    import FormButton from "../../components/form/public/Button";
    import FormToggle from "../../components/form/public/Toggle";
    import Preloader from "../../components/Preloader";
    import Modal from "../../components/Modal";
    import CheckoutBasket from "./Basket";
    import FormVoucher from "../../components/form/Voucher";

    import Form from "../../mixins/Form";

	export default {
	    data() {
	        return {
	            loading: false,
                modal: false,

	            form: {
	                payment_method: 'card',
                    marketing: false,
                    adult: false,
                    terms: false,
                    weather: false,
                    group: false,
                }
            }
        },

        props: {
            items: {
                type: Array,
                required: true,
            },

            total: {
                type: String,
                required: true,
            },

            membershipDiscount: {
                type: Number,
                default: 0
            },

            basketHasEvents: {
                type: Boolean,
                required: true,
            },

            badWeatherCover: {
                type: String
            },

            groupBookingPolicy: {
                type: String
            },
        },

		components: { PaymentOptions, FormButton, FormToggle, Preloader, Modal, CheckoutBasket, FormVoucher },

        mixins: [Form],

        computed: {
	        modalText() {
	            if (this.modal === 'weather') {
	                return {
	                    heading: 'Bad Weather Cover',
                        body: this.badWeatherCover,
                    }
                }

                return {
                    heading: 'Group Booking Guest Details Policy',
                    body: this.groupBookingPolicy,
                }
            },
        },

        methods: {
	        proceedToPayment() {
	            if (this.loading) return false;

	            this.loading = true;

                this.post('/checkout/payment')
                    .then(response => {
                        if (response.status === 200) {
                            return window.location = response.data;
                        } else if (response.status === 202) {
                            stripe.redirectToCheckout({
                                sessionId: response.data
                            }).then(function (result) {
                                // If `redirectToCheckout` fails due to a browser or network
                                // error, display the localized error message to your customer
                                // using `result.error.message`.
                            });
                        }
                    })
                    .catch(() => {
                        this.loading = false;
                    })
            },

            updateBasket() {
	            bus.$emit('update-checkout-basket-totals');
            }
        }
	}
</script>
